import React from 'react';
import Industries from '../components/Industries';

const IndustriesPage = () => {
  return (
    <main className="pt-20">
      <Industries />
    </main>
  );
};

export default IndustriesPage;
